import * as yup from 'yup'

export const schema = (t: (key: string) => string) => ({
  creditStatus: yup.string().required(t('fieldRequired')),
  creditGateway: yup.string().required(t('fieldRequired')),
  totalCreditAmount: yup.number().required(t('fieldRequired')),
  personType: yup.string().required(t('fieldRequired')),
})
